import { Button } from '@mui/material';

interface BottomFixedBtnProps {
  title?: string;
  onClick?: () => void;
  disabled?: boolean | null;
  style?: React.CSSProperties | null;
}

export default function BottomFixedBtn({
  title = '',
  onClick = () => {},
  disabled = null,
  style = null,
}: BottomFixedBtnProps) {
  return (
    <div
      className="flex flex-col p-5 justify-center w-full text-base font-bold leading-6 text-center text-white bg-white"
      style={{ zIndex: 1000, ...(style || {}) } as React.CSSProperties}
    >
      <Button variant="contained" onClick={onClick} disabled={disabled ?? false}>
        {title}
      </Button>
    </div>
  );
}
